import { useGetSeoPage } from "contexts/SeoContext";
import { FooterSeoCont, ViewAll, FooterSeoWrap } from "./styled.styles";
import { useTheme } from "styled-components";
import Accordion from "componentReusable/UIComponents/Accordion";
import { useEffect, useState } from "react";

const IS_SHOW_ALL_ENABLED = false;

const SeoArticleEmbeddedComponent = () => {
  const { isDesktop, translations } = useTheme();
  const [viewAll, setViewAll] = useState(!IS_SHOW_ALL_ENABLED);
  const [hasViewAll, setHasViewAll] = useState(false);
  const seoPage = useGetSeoPage();
  const articleText = (seoPage?.pageArticle || "").replace(/_/g, " ");

  useEffect(() => {
    if (IS_SHOW_ALL_ENABLED) {
      const element = document.getElementById("page_description") ?? null;
      if (element && element.scrollHeight > element.clientHeight)
        setHasViewAll(true);
    }
  }, [articleText]);

  if (articleText !== "SSR") {
    if (!articleText.length || !articleText) return null;
  }
  return (
    <FooterSeoCont>
      {isDesktop ? (
        <FooterSeoWrap id="page_description" viewAll={viewAll}>
          <h2 className="font-20 mb-8">{seoPage?.pageH1}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: articleText,
            }}
          />
          {hasViewAll && (
            <ViewAll className="hidden_on_ssr" onClick={() => setViewAll(true)}>
              {translations.viewMore}
            </ViewAll>
          )}
        </FooterSeoWrap>
      ) : (
        <Accordion
          className="footerSeoCont"
          items={[
            {
              title: seoPage?.pageH1,
              content: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: articleText,
                  }}
                />
              ),
            },
          ]}
        />
      )}
    </FooterSeoCont>
  );
};

export default SeoArticleEmbeddedComponent;
